import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenAbout = {
  show: async(props) => {
    const { default: AboutShow } = await import('@/vue_widgets/jensen/about/show.vue')
    createVueApp(AboutShow, { props, sidebar })
  }
}
